// src/pages/FeaturePostSection.tsx

import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { blogPosts } from "../Blog/data/blogData";

const FeaturePostSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="w-full bg-white py-26 px-5 md:px-10 lg:px-20">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {blogPosts.map((post) => (
            <article
              key={post.id}
              className="group cursor-pointer flex flex-col"
            >
              {/* Thumbnail */}
              <div className="relative overflow-hidden rounded-2xl mb-6 shadow-lg">
                <div className="aspect-[16/10] overflow-hidden bg-gray-100">
                  <img
                    src={post.thumbnail}
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="flex flex-col flex-grow">
                <div className="flex items-center gap-3 text-gray-500 text-sm mb-4">
                  <span>{post.date}</span>
                  <span className="text-gray-300">•</span>
                  <span>{post.views} {t("views")}</span>
                </div>

                <h3 className="text-2xl font-bold text-[#002F3F] mb-3 group-hover:text-gray-600">
                  <Link to={`/blogs/${post.slug}`}>
                    {t(post.titleKey ?? post.title)}
                  </Link>
                </h3>

                <p className="text-gray-600 mb-6 flex-grow">
                  {t(post.excerptKey ?? post.excerpt)}
                </p>

                <Link
                  to={`/blogs/${post.slug}`}
                  className="inline-flex items-center gap-2 font-semibold text-sm text-[#002F3F] uppercase hover:gap-3 transition-all"
                >
                  <span>{t("read_more")}</span>
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturePostSection;
